import React, { useEffect, useRef } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import AIChatBubble from "./AIChatBubble";

const SUGGESTED_PROMPTS = [
  "What was last month's QA score for ADONAI?",
  "Which staff member is improving the most?",
  "Explain the QA Compliance category.",
];

/**
 * Scrollable chat history. Auto-scrolls to the bottom on each new message,
 * shows an empty-state with suggested prompts, and a "thinking" indicator
 * while the assistant is composing a reply.
 */
export default function AIChatHistory({ messages, pending, onSuggest }) {
  const scrollRef = useRef(null);
  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [messages, pending]);

  return (
    <div ref={scrollRef} className="flex-1 overflow-y-auto p-4 space-y-3.5 text-[14.5px] bg-slate-50">
      {messages.length === 0 ? (
        <div className="text-center text-slate-500 mt-8" data-testid="ai-empty">
          <Sparkles size={28} className="mx-auto text-indigo-300 mb-2" />
          <p>Ask anything about your KPI scores, QA audits, or how to use the app.</p>
          <ul className="mt-4 space-y-2 text-[13.5px] text-slate-600">
            {SUGGESTED_PROMPTS.map((q) => (
              <li key={q}>
                <button
                  onClick={() => onSuggest(q)}
                  className="hover:bg-indigo-100 hover:text-indigo-800 rounded-md px-2 py-1 transition-colors"
                  data-testid={`ai-suggested-${q.slice(0, 20).replace(/\s+/g, "-")}`}
                >
                  {q}
                </button>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        messages.map((m, i) => (
          // Chat history is append-only — index is a stable key for a session.
          <AIChatBubble key={`${m.role}-${i}`} role={m.role} text={m.text} />
        ))
      )}
      {pending && (
        <div className="mr-auto max-w-[85%] bg-white border border-slate-200 px-3 py-2 rounded-2xl rounded-bl-sm shadow-sm flex items-center gap-2 text-slate-500">
          <Loader2 size={14} className="animate-spin" />
          <span className="text-[13.5px]">Thinking…</span>
        </div>
      )}
    </div>
  );
}
